import { jsx as r } from "react/jsx-runtime";
import { SideNavDesktopContainer as p } from "./index222.mjs";
import { SideNavProvider as v } from "./index223.mjs";
const c = ({
  isExpanded: o,
  isExpandedDefault: e,
  canCollapse: n,
  canCollapseDefault: t,
  onExpandedChange: i,
  hideCollapseButton: a,
  expandOnHover: d,
  ...m
}) => /* @__PURE__ */ r(
  v,
  {
    isExpanded: o,
    isExpandedDefault: e,
    canCollapse: n,
    canCollapseDefault: t,
    onExpandedChange: i,
    hideCollapseButton: a,
    expandOnHover: d,
    children: /* @__PURE__ */ r(N, { ...m })
  }
), N = ({ children: o, fab: e, footer: n }) => /* @__PURE__ */ r(p, { body: o, fab: e, footer: n });
export {
  c as SideNavV2
};
//# sourceMappingURL=SideNav2.mjs.map
